export const SOFTWARES_FOR_SELECT_PATH = "/v2/software" as const;

export const softwaresForSelect = {
  softwares: (searchText: string) =>
    ["softwaresForSelect", "softwares", searchText] as const,
};
